import StandardEvent from './StandardEvent';
class RedditStandardEvents {
    pageView() {
        return new StandardEvent('PageView');
    }
    viewContent() {
        return new StandardEvent('ViewContent');
    }
    addToCart() {
        return new StandardEvent('AddToCart');
    }
    addToWishlist() {
        return new StandardEvent('AddToWishlist');
    }
    purchase() {
        return new StandardEvent('Purchase');
    }
    signup() {
        return new StandardEvent('SignUp');
    }
    lead() {
        return new StandardEvent('Lead');
    }
    search() {
        return new StandardEvent('Search');
    }
}
export default RedditStandardEvents;
//# sourceMappingURL=StandardEvents.js.map